// extracted by mini-css-extract-plugin
export default {"trailsText":"styles_trailsText__F+i7w","container":"styles_container__om5xw"};